// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"b31f1dcd","208":"d75de4e3","212":"bfad83cd","258":"e9f6c54d","453":"050908d8","505":"3b5fd57d","545":"13afbbf6","797":"acc10bc1","930":"ad68acbb"}[chunkId] + ".chunk.js";
};